import type { ComponentChildren } from 'preact';
import { SUPPORT_WHATSAPP_URL } from '../../config/support.js';
import { chatAvailable, openSupport } from '../../support/supportContact.js';

/**
 * 403 (#1317): a "contact us" link. Its address stays WhatsApp (a long-press, a middle-click or a chat that never came
 * still reach someone), but while a support chat runs, the tap opens that chat in the app instead.
 */
export function SupportLink({
  className,
  children,
  'data-testid': testId,
}: {
  className?: string;
  children: ComponentChildren;
  'data-testid'?: string;
}) {
  return (
    <a
      href={SUPPORT_WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      data-testid={testId}
      onClick={(e) => {
        if (!chatAvailable()) return;
        e.preventDefault();
        openSupport();
      }}
    >
      {children}
    </a>
  );
}
